export const getElementScale = (element: HTMLElement) => {
  const style = getComputedStyle(element)
  let width = Number.parseFloat(style.width)
  if (style.boxSizing !== 'border-box') {
    width += (Number.parseFloat(style.paddingLeft) || 0) + (Number.parseFloat(style.paddingRight) || 0)
    width += (Number.parseFloat(style.borderLeftWidth) || 0) + (Number.parseFloat(style.borderRightWidth) || 0)
  }
  return element.getBoundingClientRect().width / (width || element.offsetWidth) || 1
}
